import React, { useEffect, useState } from "react";
import Navbar2 from "../Components/Navbar2";
import Footer2 from "../Components/Footer2";
import Aos from "aos";
import { useNavigate } from "react-router-dom";
import { getCommunityPosts } from "../Common/apis.js";
import Loader from "../Loader/Loader.jsx";

function DiveOur() {
  const [activeTab, setActiveTab] = useState(1);
  const [communityPosts, setCommunityPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCommunityPosts = async () => {
      setLoading(true);
      try {
        const response = await getCommunityPosts();
        if (response.data) {
          setCommunityPosts(response.data);
        } else {
          console.error("Failed to fetch community posts");
        }
      } catch (error) {
        console.error("Error fetching community posts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCommunityPosts();
  }, []);

  console.log(communityPosts);

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true
    });
  }, []);
  return (
    <>
      <div className="new-home">
        {loading && <Loader />}
        <Navbar2 />
        <div className="flex md:flex-row flex-col justify-between md:gap-0 lg:gap-[27px] gap-[45px]">
          <div className="md:pt-[83px] pt-[50px]">
            <div className="xl:flex hidden flex-col pb-[24px] gap-[12px] ml-[-70px] items-start">
              <img
                data-aos="flip-up"
                src="/assets/train/dive2.svg"
                className="xl:h-auto lg:h-[88px] md:h-[53px] h-[53px]"
                alt=""
              />
              <img
                data-aos="flip-up"
                src="/assets/train/dive1.svg"
                className="xl:h-auto lg:h-[88px] md:h-[53px] h-[53px]"
                alt=""
              />
            </div>
            <div className="flex xl:hidden flex-col pb-[45px] gap-[8px] ml-[-65px] items-start">
              <img
                data-aos="flip-up"
                src="/assets/train/mobile-dive1.svg"
                className="h-[53px]"
                alt=""
              />
              <img
                data-aos="flip-up"
                src="/assets/train/mobile-dive2.svg"
                className="h-[53px]"
                alt=""
              />
            </div>
            <div className="flex lg:flex-col flex-col-reverse">
              <div className="flex items-center lg:flex-row flex-col-reverse lg:pb-[14px] pb-0 xl:gap-[95px] gap-[40px] xl:pl-[100px] pl-[20px]">
                <div className="flex gap-[10px] flex-wrap">
                  <button
                    className={
                      activeTab === 1 ? "tab-btn-s active" : "tab-btn-s"
                    }
                    onClick={() => handleTabChange(1)}
                  >
                    All Articles
                  </button>
                  <button
                    className={
                      activeTab === 2 ? "tab-btn-s active" : "tab-btn-s"
                    }
                    onClick={() => handleTabChange(2)}
                  >
                    Newsletter
                  </button>
                  <button
                    className={
                      activeTab === 3 ? "tab-btn-s active" : "tab-btn-s"
                    }
                    onClick={() => handleTabChange(3)}
                  >
                    Media Coverage
                  </button>
                  <button
                    className={
                      activeTab === 4 ? "tab-btn-s active" : "tab-btn-s"
                    }
                    onClick={() => handleTabChange(4)}
                  >
                    Features
                  </button>
                </div>
                <div>
                  <button
                    className="lg:pt-0 pt-[26px]"
                    onClick={() => {
                      const token = localStorage.getItem("GISUL_TOKEN");
                      if (token) {
                        navigate("/profile");
                      } else {
                        navigate("/singup");
                      }
                    }}
                  >
                    <img src="/assets/train/join2.svg" alt="" />
                  </button>
                </div>
              </div>
              <div className="flex justify-center lg:px-0 px-[44px] items-center">
                <img src="/assets/train/item9.svg" alt="" />
              </div>
            </div>
          </div>
          <div>
            <div className="grid grid-cols-2 lg:gap-[16px] gap-[10px] xl:pr-[60px] pr-[20px] xl:pl-0 pl-[20px] lg:pb-0 pb-[70px]">
              <div className="flex flex-col lg:gap-[16px] gap-[10px]">
                {communityPosts
                  .filter((post) => {
                    if (activeTab === 1) return true; // All Articles
                    if (activeTab === 2) return post.category === "Newsletter";
                    if (activeTab === 3)
                      return post.category === "Media_Coverage";
                    if (activeTab === 4) return post.category === "Features";
                    return true;
                  })
                  .map((post) => (
                    <div key={post._id} className="relative rounded-[16px]">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full lg:h-[300px] h-[218px] rounded-[16px] object-cover"
                      />
                      <div className="absolute inset-0 bg-black rounded-[16px] bg-opacity-40 z-10" />
                      <div className="absolute p-[16px] z-10 bottom-0">
                        <div className="flex items-center gap-[10px] pb-[8px]">
                          <img
                            src="/assets/train/calender.svg"
                            alt="calendar"
                          />
                          <p className="font-[500] font-sans text-[14px] leading-[27px] text-[#FFFFFF]">
                            {new Date(post.createdAt).toLocaleDateString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "short",
                                day: "numeric"
                              }
                            )}
                          </p>
                        </div>
                        <p className="font-[500] capitalize text-[20px] font-sans leading-[30px] tracking-[-0.16px] text-[#FFFFFF]">
                          {post.title}
                        </p>
                      </div>
                    </div>
                  ))}
                {/* <div className="grid grid-cols-2 lg:gap-[16px] gap-[10px] xl:pr-[60px] pr-[20px] xl:pl-0 pl-[20px] lg:pb-0 pb-[70px]">
              <div className="flex flex-col lg:gap-[16px] gap-[10px]">
                <div className="relative">
                  <img src="/assets/train/img1.png" alt="" />
                  <div className="absolute p-[16px] bottom-0">
                    <div className="flex items-center gap-[10px] md:pb-[8px] pb-[4px]">
                      <img src="/assets/train/calender.svg" alt="" />
                      <p className="font-[500] font-sans lg:text-[14px] text-[11px] leading-[27px] text-[#FFFFFF]">
                        May 24, 2024
                      </p>
                    </div>
                    <p className="font-[500] lg:text-[20px] text-[16px] font-sans lg:leading-[30px] leading-[20px] tracking-[-0.16px] text-[#FFFFFF]">
                      What Is Enps? why does it matter?
                    </p>
                  </div>
                </div>
                <div className="relative">
                  <img src="/assets/train/img3.png" alt="" />
                  <div className="absolute p-[16px] bottom-0">
                    <div className="flex items-center gap-[10px] pb-[8px]">
                      <img src="/assets/train/calender.svg" alt="" />
                      <p className="font-[500] font-sans text-[14px] leading-[27px] text-[#FFFFFF]">
                        May 24, 2024
                      </p>
                    </div>
                    <p className="font-[500] text-[20px] font-sans leading-[30px] tracking-[-0.16px] text-[#FFFFFF]">
                      What Is Enps? why does it matter?
                    </p>
                  </div>
                </div>
                <div className="relative">
                  <img src="/assets/train/img2.png" alt="" />
                  <div className="absolute p-[16px] bottom-0">
                    <div className="flex items-center gap-[10px] pb-[8px]">
                      <img src="/assets/train/calender.svg" alt="" />
                      <p className="font-[500] font-sans text-[14px] leading-[27px] text-[#FFFFFF]">
                        May 24, 2024
                      </p>
                    </div>
                    <p className="font-[500] text-[20px] font-sans leading-[30px] tracking-[-0.16px] text-[#FFFFFF]">
                      What Is Enps? why does it matter?
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-[16px]">
                <div className="relative">
                  <img src="/assets/train/img1.png" alt="" />
                  <div className="absolute p-[16px] bottom-0">
                    <div className="flex items-center gap-[10px] pb-[8px]">
                      <img src="/assets/train/calender.svg" alt="" />
                      <p className="font-[500] font-sans text-[14px] leading-[27px] text-[#FFFFFF]">
                        May 24, 2024
                      </p>
                    </div>
                    <p className="font-[500] text-[20px] font-sans leading-[30px] tracking-[-0.16px] text-[#FFFFFF]">
                      What Is Enps? why does it matter?
                    </p>
                  </div>
                </div>
                <div className="relative">
                  <img src="/assets/train/img3.png" alt="" />
                  <div className="absolute p-[16px] bottom-0">
                    <div className="flex items-center gap-[10px] pb-[8px]">
                      <img src="/assets/train/calender.svg" alt="" />
                      <p className="font-[500] font-sans text-[14px] leading-[27px] text-[#FFFFFF]">
                        May 24, 2024
                      </p>
                    </div>
                    <p className="font-[500] text-[20px] font-sans leading-[30px] tracking-[-0.16px] text-[#FFFFFF]">
                      What Is Enps? why does it matter?
                    </p>
                  </div>
                </div>
                <div className="relative">
                  <img src="/assets/train/img2.png" alt="" />
                  <div className="absolute p-[16px] bottom-0">
                    <div className="flex items-center gap-[10px] pb-[8px]">
                      <img src="/assets/train/calender.svg" alt="" />
                      <p className="font-[500] font-sans text-[14px] leading-[27px] text-[#FFFFFF]">
                        May 24, 2024
                      </p>
                    </div>
                    <p className="font-[500] text-[20px] font-sans leading-[30px] tracking-[-0.16px] text-[#FFFFFF]">
                      What Is Enps? why does it matter?
                    </p>
                  </div>
                </div>
              </div>
            </div> */}
              </div>
            </div>
          </div>
        </div>
        <Footer2 />
      </div>
    </>
  );
}

export default DiveOur;
